var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ht-tab-wrap"},[_c('b-tabs',{staticClass:"ht-tab-menu wow move-up"},[_c('b-tab',{attrs:{"title":"Featured","active":""}},[_c('TabContentOne')],1),_c('b-tab',{attrs:{"title":"Our mission"}},[_c('TabContentTwo')],1),_c('b-tab',{attrs:{"title":"New Friendly Support"}},[_c('TabContentThree')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }